import React, { useEffect, useRef, useState } from "react";
import { setAdditionalClasses } from "../assets/js/utils";
import useWindowSize from "./hooks/useWindowSize";

function TabSelector({ tabs, contents }) {
  const [selectedTab, setSelectedTab] = useState(0);
  const [applyAnimation, setApplyAnimation] = useState(false);
  const [halfWidthHeader, setHalfWidthHeader] = useState(false);
  const tabBodyRef = useRef();

  const windowWidth = useWindowSize();

  function handleScrollPosition(e) {
    //90 is the height of the --header-main-height in css
    if (window.scrollY > window.innerHeight + 95 && windowWidth < 767) {
      setHalfWidthHeader(true);
    } else {
      setHalfWidthHeader(false);
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScrollPosition);

    return function () {
      document.removeEventListener("scroll", handleScrollPosition);
    };
  });

  useEffect(() => {
    setApplyAnimation(true);
    setTimeout(() => {
      setApplyAnimation(false);
    }, 1200);
    if (tabBodyRef.current && selectedTab) {
      tabBodyRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [selectedTab, tabBodyRef]);

  const handleTabPress = (index) => {
    setSelectedTab(index);
  };
  return (
    <div className="tab-selector">
      <header
        className={`tab-selector__header${setAdditionalClasses(
          ["half-width"],
          [halfWidthHeader]
        )}`}
      >
        {tabs.map((tab, index) => (
          <span
            className={`tab-selector__link${setAdditionalClasses(
              ["active-tab"],
              [index === selectedTab]
            )}`}
            key={index}
            onClick={() => handleTabPress(index)}
          >
            {tab}
          </span>
        ))}
      </header>
      <div
        ref={tabBodyRef}
        className={`tab-selector__body${setAdditionalClasses(
          ["animate-tab-selector"],
          [applyAnimation]
        )}`}
      >
        {contents[selectedTab]}
      </div>
    </div>
  );
}

export default TabSelector;
